import { h } from 'vue';
import { ElInputNumber } from 'element-plus/es';
import 'element-plus/es/components/input-number/style/index';
import "core-js/modules/es.array.push.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.find.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/esnext.iterator.map.js";
import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
  class: "user-upload"
};
const _hoisted_2 = {
  key: 0,
  class: "reply-text mb-4"
};
const _hoisted_3 = {
  class: "keyword-content min-h-12"
};
const _hoisted_4 = {
  class: "key-word mt-3"
};
const _hoisted_5 = {
  class: "left-box flex-1 overflow-hidden"
};
const _hoisted_6 = {
  key: 0,
  class: "preview-text"
};
const _hoisted_7 = {
  class: "loading-block"
};
const _hoisted_8 = {
  class: "text-xs text-[#4E5969] mt-1"
};
const _hoisted_9 = {
  class: "right-box flex-1 overflow-hidden"
};
const _hoisted_10 = {
  class: "footer-block mt-2"
};
const _hoisted_11 = {
  key: 0
};
const _hoisted_12 = {
  key: 1
};
import { computed, ref, onMounted, reactive, inject, onUnmounted, toRaw } from 'vue';
import { ElMessageBox, ElMessage } from 'element-plus';
import MenuBlock from '@components/MenuBlock.vue';
import { typewriterEffect } from '@utils/window-helpers';
import initIncrementalUpdate from '@views/main/components/report-items/mixins/incrementalUpdate.mixin';
import ConfirmWord from './components/ConfirmWord.vue';
import GenerateItem from './components/GenerateItem.vue';
import useMainStore, { storeToRefs } from '../../main.store';
import { pubWorkflow, updateFileContent } from '../../api';
export default /*@__PURE__*/_defineComponent({
  __name: 'UserKeyword',
  props: {
    item: {},
    content: {}
  },
  setup(__props) {
    const props = __props;
    const defaultData = () => {
      return {
        genTotalCount: 0,
        keywordCount: 1,
        done: false,
        knowledgeDetails: []
      };
    };
    const mainStore = useMainStore();
    const {
      messageContentMap,
      incrementalMessageList
    } = storeToRefs(mainStore);
    const messageContent = ref([]);
    const activeIns = ref(0); // 选中的tab
    const activeItem = ref({}); // 当前选中的文件
    const isCustom = ref(false); // 是否自定义(true 则不触发自动切换跟踪逻辑)
    const info = ref(defaultData());
    const test = item => {
      debugger;
      // 使用 reactive 包裹新创建的对象
      const reactiveItem = reactive({
        ...item,
        animationText: ''
      });
      info.value.knowledgeDetails.push({
        knowledgeId: Math.random().toString(36).substring(2),
        keyword: '企业基础信息',
        attachmentDetails: [reactiveItem] // 使用响应式对象
      });
      typewriterEffect(reactiveItem.text.slice(reactiveItem.animationText.length), currentText => {
        // 修改响应式对象的属性
        reactiveItem.animationText += currentText;
      }, () => {
        activeItem.value.animationText = reactiveItem.text;
      });
      if (isCustom.value) return;
      // eslint-disable-next-line no-use-before-define
      handleClickFull(info.value.knowledgeDetails.at(-1).attachmentDetails.at(-1));
    };
    const tabList = computed(() => {
      const list = [];
      info.value.knowledgeDetails.forEach((item, ins) => {
        list.push({
          label: item.keyword,
          value: ins
        });
      });
      return list;
    });
    const showActiveList = computed(() => {
      const list = [[], []];
      const arr = info.value?.knowledgeDetails[activeIns.value]?.attachmentDetails || [];
      arr.forEach((item, ins) => {
        list[ins % 2].push(item);
      });
      return list;
    });
    const totalAttachmentDetails = computed(() => {
      const ret = [];
      info.value?.knowledgeDetails.forEach(item => {
        item.attachmentDetails.forEach(file => {
          ret.push(file);
        });
      });
      return ret;
    });
    function handleClickFull(item) {
      activeItem.value = item;
    }
    function handleWordFileClick(file) {
      if (file.checked) {
        file.checked = false;
      } else {
        file.checked = true;
        isCustom.value = true;
        handleClickFull(file);
      }
    }
    function handleChangeTab() {
      isCustom.value = true;
    }
    const openSideEdit = inject('openSideEdit');
    const handleToggleFull = () => {
      const obj = info.value.knowledgeDetails[activeIns.value];
      let sonIns = obj.attachmentDetails.findIndex(item => item.fileId === activeItem.value.fileId) || 0;
      sonIns = sonIns < 0 ? 0 : sonIns;
      debugger;
      openSideEdit({
        type: 'edit_keyword',
        typeQuery: {
          active: activeIns.value,
          sonIns
        },
        contentData: toRaw(info.value),
        title: '编辑内容',
        callBack: (data, item) => {
          info.value = data;
          updateFileContent({
            id: item.fileId,
            fileContent: JSON.stringify({
              bodyText: item.text,
              keyword: item.keyword,
              subject: item.fileName
            })
          }).then(() => {
            ElMessage.success('保存成功');
          });
        }
      });
    };
    const confirmEmpty = async list => {
      const msg = list.join('、');
      return new Promise((resolve, reject) => {
        ElMessageBox.confirm(`关键词【${msg}】没有选择语料库，不会生成对应文章，是否继续？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          resolve(true);
        }).catch(() => {
          resolve(false);
        });
      });
    };
    const showInputNumberDialog = keywordCount => {
      return new Promise((resolve, reject) => {
        const inputNumberValue = ref(5);
        ElMessageBox({
          title: '',
          message: () => h('div', [h('div', {
            style: 'margin-bottom: 8px;'
          }, '是否确认基于当前语料库进行内容生成操作？'), h('span', {
            style: 'margin-right: 10px;'
          }, '每个关键词生成'), h(ElInputNumber, {
            'modelValue': inputNumberValue.value,
            'min': 1,
            'max': 50,
            'step': 1,
            'controls': false,
            'onUpdate:modelValue': val => {
              inputNumberValue.value = val;
            }
          }), h('span', {
            style: 'margin-left: 10px;'
          }, '篇'), h('div', {
            style: 'margin-top: 12px;'
          }, `按照本次生成文章数量，预计消耗${keywordCount * (inputNumberValue.value || 0) * 1}点权益点`), h('div', {
            style: 'margin-top: 12px;'
          }, `权益结算规则：(${keywordCount}个关键词 * ${inputNumberValue.value || 0}篇文章 * 1点权益)`)]),
          showCancelButton: true,
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        }).then(() => {
          resolve(inputNumberValue.value);
        }).catch(() => {
          resolve(false);
        });
      });
    };
    const clickSure = async () => {
      const knowledgeDetails = [];
      const empty = [];
      info.value.knowledgeDetails.forEach(k => {
        const checkedList = k.attachmentDetails.filter(item => item.checked);
        if (checkedList.length) {
          knowledgeDetails.push({
            keyword: k.keyword,
            keywordId: k.keywordId,
            attachmentDetails: checkedList.map(f => ({
              fileId: f.fileId,
              fileName: f.fileName,
              filePath: f.filePath,
              knowledgeId: f.knowledgeId
            }))
          });
        } else {
          empty.push(k.keyword);
        }
      });
      if (!knowledgeDetails.length) {
        return ElMessage.warning('请选择知识库');
      }
      if (empty.length) {
        const sure = await confirmEmpty(empty);
        if (!sure) return;
      }
      const ret = await showInputNumberDialog(knowledgeDetails.length);
      if (ret) {
        const params = {
          optType: 'GEN_ARTICLE_CONTENT',
          sessionId: mainStore.msgParams.sessionId,
          sourceId: props.item.id,
          knowledgeDetails,
          genCount: ret
        };
        try {
          await pubWorkflow(params);
          ElMessage.success('提交成功');
        } catch (error) {
          console.error('API调用失败:', error);
        }
      }
    };
    const {
      handleIncrementalMessage
    } = initIncrementalUpdate(async message => {
      const {
        incrementalData
      } = message;
      info.value.done = incrementalData.done;
      let knowledgeItem = info.value.knowledgeDetails.find(item => item.keywordId === incrementalData.keywordId);
      if (!knowledgeItem) {
        knowledgeItem = {
          keyword: incrementalData.keyword,
          keywordId: incrementalData.keywordId,
          attachmentDetails: []
        };
        info.value.knowledgeDetails.push(knowledgeItem);
      }
      const file = incrementalData.content;
      if (file) {
        let obj;
        if (file.fileContent) {
          obj = JSON.parse(file.fileContent);
        }
        if (obj) {
          file.fileName = obj.subject;
          file.keyword = obj.keyword;
          file.animationText = obj.bodyText;
          file.text = file.animationText;
        }
        file.text = file.animationText;
        knowledgeItem.attachmentDetails.push(file);
      }
      console.log('incrementalData.success', incrementalData.success);
      if (incrementalData.done) {
        mainStore.loadNextMsg(props.item);
      }
    });
    onUnmounted(() => {
      mainStore.componentFunMap.delete(props.item.id);
    });
    onMounted(() => {
      console.log('props', props, messageContentMap);
      if (props.item.id) {
        mainStore.componentFunMap.set(props.item.id, handleIncrementalMessage);
      }
      try {
        let doneCount = 0;
        if (props.content) {
          info.value = props.content;
          messageContent.value = messageContentMap.value[props.item.id] || [];
          if (!info.value.knowledgeDetails) {
            info.value.knowledgeDetails = [];
          }
          info.value.knowledgeDetails.forEach(item => {
            item.attachmentDetails.forEach(file => {
              const attach = messageContent.value.find(son => son.id === file.fileId);
              let obj;
              if (attach.strFileContent) {
                obj = JSON.parse(attach.strFileContent);
              }
              if (obj) {
                doneCount++;
                file.fileName = obj.subject;
                file.animationText = obj.bodyText;
                file.text = file.animationText;
              }
            });
          });
        }
        // 处理增量数据
        if (props.item.incrementalIds) {
          props.item.incrementalIds.forEach(id => {
            handleIncrementalMessage(incrementalMessageList.value[id]);
          });
        }
        if (info.value.genTotalCount > 0 && info.value.genTotalCount == doneCount) {
          info.value.done = true;
        }
        if (info.value.done) {
          mainStore.loadNextMsg(props.item);
        }
      } catch (error) {
        debugger;
        info.value = defaultData();
        console.log(error);
      }
    });
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [info.value.tips ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(info.value.tips), 1)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_3, [_createVNode(MenuBlock, {
        modelValue: activeIns.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => activeIns.value = $event),
        list: tabList.value,
        onChange: handleChangeTab
      }, null, 8, ["modelValue", "list"]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(showActiveList.value[0], son => {
        return _openBlock(), _createBlock(ConfirmWord, {
          key: son.knowledgeId,
          name: son.fileName,
          checked: son.checked,
          active: son.fileId && activeItem.value.fileId === son.fileId,
          onClick: $event => handleWordFileClick(son),
          onClickFull: $event => handleClickFull(son)
        }, null, 8, ["name", "checked", "active", "onClick", "onClickFull"]);
      }), 128))]), !info.value.done ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_cache[1] || (_cache[1] = _createElementVNode("div", {
        class: "loader"
      }, null, -1)), _cache[2] || (_cache[2] = _createElementVNode("div", {
        class: "text-xs text-[#4E5969] mt-1"
      }, "AI正在对内容生成中……", -1)), _createElementVNode("div", _hoisted_8, " ( " + _toDisplayString(totalAttachmentDetails.value.length) + " / " + _toDisplayString(info.value.genTotalCount) + " ) ", 1)])])) : (_openBlock(), _createBlock(GenerateItem, {
        key: 1,
        title: activeItem.value.fileName,
        text: activeItem.value.animationText,
        generating: activeItem.value.animationText === activeItem.value.text,
        onToggleFull: handleToggleFull
      }, null, 8, ["title", "text", "generating"])), _createElementVNode("div", _hoisted_9, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(showActiveList.value[1], son => {
        return _openBlock(), _createBlock(ConfirmWord, {
          key: son.knowledgeId,
          name: son.fileName,
          checked: son.checked,
          active: son.fileId && activeItem.value.fileId === son.fileId,
          onClick: $event => handleWordFileClick(son),
          onClickFull: $event => handleClickFull(son)
        }, null, 8, ["name", "checked", "active", "onClick", "onClickFull"]);
      }), 128))])])]), _cache[4] || (_cache[4] = _createElementVNode("div", {
        class: "footer-tip mt-6"
      }, " 您确认的资料将被用于AI模型处理并在全网进行GEO内容策略执行。此授权操作一旦确认将无法撤销，请谨慎确认。 ", -1)), _createElementVNode("div", _hoisted_10, [info.value.done ? (_openBlock(), _createElementBlock("div", _hoisted_11, "本次任务消耗" + _toDisplayString(totalAttachmentDetails.value.length * 1) + "点", 1)) : (_openBlock(), _createElementBlock("div", _hoisted_12, "生成中……")), _createVNode(_component_el_button, {
        disabled: !info.value.done,
        type: "primary",
        onClick: clickSure
      }, {
        default: _withCtx(() => [...(_cache[3] || (_cache[3] = [_createTextVNode(" 使用知识库生成文章 ", -1)]))]),
        _: 1
      }, 8, ["disabled"])])]);
    };
  }
});